import { handleAPIError } from "@services/Base";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { CLIENT_API_URL } from "../../../config";
import { ClientShort } from "../types";

export const useClients = () => {
  return useQuery({
    queryKey: ["clients"], // Key used to cache the request
    queryFn: ({ signal }) =>
      axios
        .get(`${CLIENT_API_URL}/waves-client-manager-api/v1/clients/`, {
          signal
        })
        .then((response) => {
          return response.data as ClientShort[];
        })
        .catch((error) => {
          return handleAPIError(error);
        })
  });
};
